<script>
export default {
    name: 'MapIcon',
};
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M1 6V22L8 18L16 22L23 18V2L16 6L8 2L1 6Z"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path d="M8 2V18" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M16 6V22"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-dasharray="1 1"
        />
    </svg>
</template>

<style scoped></style>
